import { render, staticRenderFns } from "./ContributeTable.vue?vue&type=template&id=cf873cc0&scoped=true"
import script from "./ContributeTable.vue?vue&type=script&lang=js"
export * from "./ContributeTable.vue?vue&type=script&lang=js"
import style0 from "./ContributeTable.vue?vue&type=style&index=0&id=cf873cc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf873cc0",
  null
  
)

export default component.exports